import { UI } from '../../../core/static/js/helpers/UI.js'
import { setCookie, getCookie } from '../../../core/static/js/helpers/utils.js'

const specialsUI = {
  body: UI.find("body"),
  specialsTicker: UI.find('.specials-ticker'),
  imageGallery: UI.find('.image-carousal-wrapper'),
  primaryNav: document.querySelector("header"),
  cardImgs: document.querySelectorAll('.product-card .card .picture img')
}

function showGallery(el) { //Show Carousal Gallery
  specialsUI.imageGallery.classList.remove('out-of-sight');
  specialsUI.primaryNav.classList.add('inverse');
}

function hideGallery(el) { //Hide Carousal Gallery
  specialsUI.imageGallery.classList.add('out-of-sight');
  specialsUI.primaryNav.classList.remove('inverse');
  let cardImgs = document.querySelectorAll('.product-card .card .picture img')
  if (cardImgs) {
      for (const cardImg of cardImgs) {
        cardImg.classList.remove('transition');
      }
    }
}

function toggleCardImages(el) { //toggle card images
  let pictureOne = el.querySelector('.one');
  let pictureTwo = el.querySelector('.two');
  if ( pictureTwo && pictureTwo.classList.contains('out-of-sight-x') ){
    pictureOne.classList.add('out-of-sight-x');
    pictureTwo.classList.remove('out-of-sight-x');
  } else {
    pictureOne.classList.remove('out-of-sight-x');
    if (pictureTwo) {
      pictureTwo.classList.add('out-of-sight-x');
    }
  }
}

function stickDetailsBlock() { //Stick details section till it reaches footer
  let spacer = UI.find('#productGridEnder');
  if (spacer) {
    let windowH = window.innerHeight;
    let xPos = spacer.offsetTop - windowH;
    if(specialsUI.specialsTicker){
      if (window.scrollY > xPos) {
        specialsUI.specialsTicker.classList.remove('sticky');
      }
      else {
        specialsUI.specialsTicker.classList.add('sticky');
      }
    }
  }
}

function saveSinglePageCollectionSizeData(size, category){
  // Saves the preferred/selected size of the collection to the cookie
  let collectionsData = getCookie('collections_data');
  if (collectionsData){
    let collectionsList = JSON.parse(collectionsData);
    if (collectionsList && collectionsList.length > 0){
        let collection = collectionsList.find(function(c){
            return c.hasOwnProperty(category);
        });
        if (collection){
            collection[category] = size;
            setCookie('collections_data', JSON.stringify(collectionsList), 10*365);
        }
        else{
            collectionsList.push({[category]: size});
            setCookie('collections_data', JSON.stringify(collectionsList), 10*365);
        }
    } 
  }
  else{
    collectionsData = [];
    let collection = {[category]: size};
    collectionsData.push(collection);
    setCookie('collections_data', JSON.stringify(collectionsData), 10*365);
  }
}

function getCategorySizeFromCookies(){
  let globalSizePicker = document.querySelector(
    "#specials .global-size-picker select"
  );
  let size = null;
  if (globalSizePicker) {
      let category = globalSizePicker.getAttribute('data-category');
      let collectionsData = getCookie('collections_data');
      if (collectionsData){
        let collectionsList = JSON.parse(collectionsData);
        if (collectionsList && collectionsList.length > 0){
            let collection = collectionsList.find(function(c){
                return c.hasOwnProperty(category);
            });
            if (collection){
                size = collection[category];
            }
        } 
      }
  }
  return size;
}

function attachEventListeners() {
    
  //Common function to invoke subscribe popup 
  let subscribeLinks = UI.findAll('.subscribe-modal-link');
  if (subscribeLinks) {
    for (var i = 0; i < subscribeLinks.length; i++) {
      subscribeLinks[i].addEventListener('click', function (e) {
        event.preventDefault();
        UI.showModal('subscribeForm');
      });
    }
  }
  
   //Toggle images on click
    let cardLinks = document.querySelectorAll('.inline-buy .card .card-link');
    if (cardLinks) {
      for (const cardLink of cardLinks) {
        cardLink.addEventListener('click', function (event) {
          event.preventDefault();
          let card = cardLink.closest('.card')
          toggleCardImages(card)
        });
      }
    }
  let globalSizePicker = document.querySelector(
    "#specials .global-size-picker select"
  );
  if (globalSizePicker) {
    globalSizePicker.addEventListener("change", function () {
      // Cookie store new size of current category
      let category = globalSizePicker.getAttribute('data-category')
      const selectedValue = this.value;
      saveSinglePageCollectionSizeData(selectedValue,category);
      var currentUrl = window.location.href;
      var urlParts = currentUrl.split("?");
      var baseUrl = urlParts[0];
      currentUrl = baseUrl;
      window.location.href = currentUrl;
      globalSizePicker.value = selectedValue
    });
  }
}

function setGlobalSelectSize(){
  let currentSize = getCategorySizeFromCookies()
  if(currentSize){
    let globalSizePicker = document.querySelector(
      "#specials .global-size-picker select"
    );
    globalSizePicker.value = currentSize
  }
}

window.addEventListener('load', function(){
  let globalSizePicker = document.querySelector(
    "#specials .global-size-picker select"
  );
  if (globalSizePicker) {
    let category = globalSizePicker.getAttribute('data-category')
    let style = globalSizePicker.getAttribute('data-style')
    let size = globalSizePicker.getAttribute('data-size')
    saveSinglePageCollectionSizeData(size, category);
  }
  setGlobalSelectSize();
})
window.addEventListener('DOMContentLoaded', function (){
  attachEventListeners();
  stickDetailsBlock();


});

window.addEventListener('scroll', function () { //Scroll Events
  stickDetailsBlock();
});
